import {css} from '@emotion/react'
import StartpageLogo from '../../../images/startpage/logo-clipped.svg'

const translations = {
    en: {
        titleHighlight: 'Private AI',
    },
    fr: {
        titleHighlight: 'IA privée',
    },
    de: {
        titleHighlight: 'Private KI',
    },
    nl: {
        titleHighlight: 'Privé AI',
    },
}

const SubLogo = ({languageCode = 'en'}) => {
    const text = translations[languageCode] || translations.en

    return (
        <div
            className="subtitle-container"
            css={css`
                display: flex;
                align-items: center;
                gap: 6px;
            `}
        >
            <StartpageLogo
                css={css`
                    width: 100px;
                `}
            />
            <span
                className="highlight"
                css={css`
                    color: var(--text-tertiary, #0fe);
                    font-family: Inter;
                    font-size: 19.752px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 23.926px; /* 121.131% */
                    letter-spacing: 0.059px;
                    margin-bottom: 4px;
                `}
            >
                {text.titleHighlight}
            </span>
        </div>
    )
}

export default SubLogo
